import React from 'react'

const FileIcon = ({ size = 16, color = '#dc2626', ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            viewBox="0 0 16 16"
            {...props}
        >
            <path
                fill={color}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 0H3C2.45 0 2 0.45 2 1V15C2 15.55 2.45 16 3 16H13C13.55 16 14 15.55 14 15V5L9 0ZM12 14H4V2H8V6H12V14Z"
            />
        </svg>
    )
}

export default FileIcon
